<template>
  <div>
    <h4 class="ui header" v-html="data.question"></h4>
    <div :class="`ui ${loading ? 'active' : ''} centered inline green loader`"></div>
    <template v-if="!loading">
      <BarChart v-if="submitted" :series="series" :options="chartOptions"></BarChart>
      <template v-else>
        <p v-for="(response, i) in data.responses" :key="`response-${i}`">
          <button class="ui blue button" @click="submit(response)">{{response.text}}</button>
        </p>
      </template>
    </template>
    <p class="disclaimer"><i>*Interactions are designed to help learning retention only. Interaction data is not stored for reporting.</i></p>
  </div>
</template>

<script>
import ScormService from '@/services/scorm/scorm.js';
import ContentService from '@/services/api/content/content-service';
import BarChart from '@/components/shared/charts/Bar';

export default {
  name: 'Poll',
  props: ['id', 'type', 'data', 'standard'],
  components: {
    BarChart,
  },
  data() {
    return {
      submitted: false,
      loading: false,
      series: [],
      chartOptions: {
        title: {
          text: '',
        },
        xAxis: {
          categories: ' ',
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Percentage of Votes',
          },
        },
        tooltip: {
          headerFormat:
            '<span style=\'font-size:10px\'>{point.key}</span><table>',
          pointFormat:
            '<tr><td style=\'color:{series.color};padding:0\'>{series.name}: </td>' +
            '<td style=\'padding:0\'><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
      },
    };
  },
  computed: {
    contentSyncguid() {
      return this.$route.params.syncguid;
    },
  },
  methods: {
    saveSCORMInteraction(response) {
      const scormData = {
        id: this.id,
        type: this.type,
        isCorrect: 'n/a',
        answer: JSON.stringify(response),
        description: this.data.question,
      };
      ScormService.saveSCORMInteraction(scormData);
    },
    submit(response) {
      this.loading = true;
      ContentService.postInteractionResponse(this.contentSyncguid, {
        interactionId: this.id,
        response: response.label || response.text,
      }).then(() => {
        this.submitted = true;
        ContentService.getInteractionResponses(this.contentSyncguid, {
          interactionId: this.id,
        }).then(res => {
          this.series = res.map(r => {
            return { name: r.response, data: [r.percentage * 100] };
          });
          this.loading = false;
        });
      });
      if (this.standard === 'SCORM_2004') {
        this.saveSCORMInteraction(response);
      }
    },
  },
};
</script>
